import fetch from '@adc/fetch'

export const fetchApplicationSessionInformation = async params => {
  const { page, take, channel = 'WEB', read, displayed } = params
  const response = await fetch.forAuctionGraph({
    query: `
         query toolkitAdc_fetchApplicationSessionInformation ($channel: NotificationChannelType!, $page: NonNegativeInt, $take: PositiveInt, $displayed: Boolean, $read: Boolean) {
           current_user {
              onboarding_answers {
               question_code
              }
              purchase_profiles {
                ... on ReoPurchaseProfile {
                  percent_complete
                }
              }
             notifications(filters: {channel: $channel, page: $page, take: $take, displayed: $displayed, read: $read }) {
               content {
                 content
                 read
                 displayed
                 message_id
                 notification_intent_code
                 created_date
               }
               total_elements
               total_count
               current_page
               total_pages
             }
           }
         }
      `,
    variables: {
      channel,
      page,
      take,
      displayed,
      read,
    },
  })
  // eslint-disable-next-line camelcase
  return response?.body.data?.current_user || {}
}
/**
 * Marks all notifications as read via GraphQL mutation.
 * @returns {Promise<any>}
 */
export const markAllNotificationsAsRead = () =>
  fetch.forAuctionGraph({
    query: `
      mutation toolkitAdc_markAllNotificationsAsRead {
        markAllNotificationsAsRead
      }
    `,
  })

/**
 * Clears all notifications as read via GraphQL mutation.
 * @returns {Promise<any>}
 */
export const clearAllNotifications = () =>
  fetch.forAuctionGraph({
    query: `
      mutation toolkitAdc_clearAllNotifications {
        clearAllNotifications
      }
    `,
  })
